import { Controller } from 'stimulus';

class ArticleController extends Controller {
  connect() {
    this.API_URL = this.data.get('api');
  }

  onMoreArticlesClick(e) {
    const { nextPage } = e.target.dataset;

    this.fetchArticles(nextPage)
      .then(ArticleController.extractArticlesFromResponse)
      .then((articlesElement) => {
        $(this.articlesTarget).append(articlesElement.innerHTML);
        $(this.moreArticlesTarget).remove();
      });
  }

  fetchArticles(page) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${this.API_URL}?page=${page}`,
        success: resolve,
        error: reject,
      });
    });
  }

  static extractArticlesFromResponse(response) {
    const $articles = $(response).find('[data-target="article.articles"]');

    if (!$articles.length) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject('Missing article.articles target in response');
    }

    return Promise.resolve($articles[0]);
  }
}

ArticleController.targets = [
  'articles',
  'moreArticles',
];

export default ArticleController;
